// Post-login Workspace Selection (shown when a user can access more than one workspace).
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Building2, ArrowRight, LogOut } from 'lucide-react';

export function WorkspaceSelectionPage() {
  const { workspaces, setActiveWorkspace, logout, user } = useAuth();
  const navigate = useNavigate();

  const choose = (id) => {
    setActiveWorkspace(id);
    navigate('/portal');
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4" data-testid="workspace-selection">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-sky-500/20 mb-4">
            <Building2 className="h-7 w-7 text-sky-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Select Workspace</h1>
          <p className="text-slate-400 mt-1 text-sm">Welcome back, {user?.name}. Choose where you'd like to work.</p>
        </div>

        <div className="space-y-3">
          {workspaces.map((w) => (
            <button
              key={w.id}
              onClick={() => choose(w.id)}
              className="w-full text-left bg-slate-800 hover:bg-slate-750 border border-slate-700 hover:border-sky-500 rounded-xl p-5 transition-colors group flex items-center justify-between"
              data-testid={`workspace-option-${w.key}`}
            >
              <div>
                <p className="text-white font-semibold">{w.name}</p>
                <p className="text-slate-400 text-sm mt-0.5">{w.description || 'Workspace'}</p>
              </div>
              <ArrowRight className="h-5 w-5 text-slate-500 group-hover:text-sky-400 transition-colors" />
            </button>
          ))}
        </div>

        <button onClick={logout} className="mt-6 mx-auto flex items-center gap-2 text-slate-500 hover:text-slate-300 text-sm" data-testid="workspace-logout">
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>
    </div>
  );
}

export default WorkspaceSelectionPage;
